// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "(min-width: 1024px)";
var _4 = "services__switcher-39_Ka";
var _5 = "baggage_full-B37rG";
var _6 = "segment__direction-XSP-S";
var _7 = "service__name-zunkl";
var _8 = "baggage__service-1bEub";
var _9 = "service__values-2jFRO";
var _a = "content-2vosF";
var _b = "selected-2EMhk";
var _c = "included-mwjwn";
var _d = "checkbox-1akMV";
var _e = "checkbox_active-1uVsF";
var _f = "baggage-20lb0";
var _10 = "carryon-1xYf7";
var _11 = "service__sizes-31Zww";
var _12 = "service__price-3O2Ff";
var _13 = "not_selected-2mdzE";
var _14 = "addButton_disabled-1617E";
var _15 = "addButton-3CDsl";
var _16 = "addButton_add-2q95Q";
var _17 = "addButton__icon-1PDse";
export { _1 as "__esModule", _2 as "tablet", _3 as "desktop_only", _4 as "services__switcher", _5 as "baggage_full", _6 as "segment__direction", _7 as "service__name", _8 as "baggage__service", _9 as "service__values", _a as "content", _b as "selected", _c as "included", _d as "checkbox", _e as "checkbox_active", _f as "baggage", _10 as "carryon", _11 as "service__sizes", _12 as "service__price", _13 as "not_selected", _14 as "addButton_disabled", _15 as "addButton", _16 as "addButton_add", _17 as "addButton__icon" }
export default { "__esModule": _1, "tablet": _2, "desktop_only": _3, "services__switcher": _4, "baggage_full": _5, "segment__direction": _6, "service__name": _7, "baggage__service": _8, "service__values": _9, "content": _a, "selected": _b, "included": _c, "checkbox": _d, "checkbox_active": _e, "baggage": _f, "carryon": _10, "service__sizes": _11, "service__price": _12, "not_selected": _13, "addButton_disabled": _14, "addButton": _15, "addButton_add": _16, "addButton__icon": _17 }
